import { Injectable, inject, Signal } from '@angular/core';
import { Course } from '@lyceo/shared/plan/util-models';
import { Store } from '@ngrx/store';
import * as CourseSelectors from './course.selectors';
import { AutocompleteOption } from '@lyceo/shared/util-models';

@Injectable({
  providedIn: 'root',
})
export class CourseFacade {
  private readonly store: Store = inject(Store);

  public getAll: Signal<Course[]> = this.store.selectSignal(
    CourseSelectors.selectAllCourses,
  );

  public getAllAsOption: Signal<AutocompleteOption<Course>[]> =
    this.store.selectSignal(CourseSelectors.selectAllCoursesAsOptions);
}
